<template>
  <div>
    <div class="row">
      <div class="col">
        <v-date-picker
          v-model="startRental"
          :min-date="tomorrowDate"
          :disabled-dates="{ weekdays: [1] }"
        >
          <template v-slot="{ inputValue, togglePopover }">
            <input
              :value="inputValue"
              class="form-control"
              placeholder="Ingresar fecha en calendario"
              readonly
              @click="togglePopover()"
            />
          </template>
        </v-date-picker>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col text-center">
        <span
          class="text-decoration-underline cursor-pointer fs-7" :class="[indefiniteStartRental ? 'primary-text-color' : 'text-secondary']"
          @click="indefiniteStartRental = !indefiniteStartRental"
        >
          Prefiero verlo más adelante
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';

  import DatePickerLangMixin from '../../../../common/mixins/datepicker_lang';
  import segmentTrack from '../../../../common/mixins/segmentTrack'

  export default {
    mixins: [DatePickerLangMixin, segmentTrack],

    components: { DatePicker },

    mounted() {
      this.sendSegmentTrack('MEXICAN_WAREHOUSE_BOT_SEGMENT_PUBLIC', 'Mexican Warehouse Rental Bot', 'Choose Start Rental Step')
    },

    computed:{
      ...mapGetters(['isDisabledDate']),

      startRental: {
        get () {
          return this.$store.state.warehouseRental.startRental;
        },

        set (value) {
          if (value === null) return;

          this.$store.commit('setWarehouseRental', { startRental: value, indefiniteStartRental: null });
        }
      },

      indefiniteStartRental: {
        get () {
          return this.$store.state.warehouseRental.indefiniteStartRental;
        },

        set (value) {
          if (value === null) return;

          this.$store.commit('setWarehouseRental', { indefiniteStartRental: value, startRental: null });
        }
      },

      tomorrowDate() {
        const date = new Date();
        date.setDate(date.getDate() + 1);
        return date;
      }
    }
  }
</script>
